/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="30" height="30" viewBox="0 0 30 30" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M16.55,18.34a2.48,2.48,0,0,1-2.11-1.07s-.5,2-.6,2.36a9.12,9.12,0,0,1-1.56,2.82.11.11,0,0,1-.2-.05,9.39,9.39,0,0,1,0-3.27c.17-.7,1.11-4.69,1.11-4.69a3.38,3.38,0,0,1-.27-1.37c0-1.27.74-2.23,1.66-2.23a1.16,1.16,0,0,1,1.16,1.3,18.47,18.47,0,0,1-.76,3,1.33,1.33,0,0,0,1.36,1.66c1.63,0,2.73-2.09,2.73-4.58,0-1.89-1.27-3.3-3.58-3.3a4.08,4.08,0,0,0-4.25,4.13,2.52,2.52,0,0,0,.57,1.69.43.43,0,0,1,.13.48c-.05.15-.14.54-.18.69a.29.29,0,0,1-.43.21,3.32,3.32,0,0,1-1.76-3.29c0-2.45,2.06-5.38,6.15-5.38a5.15,5.15,0,0,1,5.46,4.94c0,3.37-1.88,5.9-4.65,5.9M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0" style={{ fillRule: 'evenodd' }} className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PinterestIcon';

export default Icon;
